module.exports = "/assets/data/6d773b102927c0d658ace60a8abb1920-WC2N.data.json";